import {Component, ElementRef, inject, input, output, viewChild} from '@angular/core';
import {ObjectData} from '../../../services/objekt-data.service';
import {ObjektModels} from '../../../models/objekt-models';
import {FormControl} from '@angular/forms';
import {BehaviorSubject, catchError, of, startWith, Subject, switchMap, tap} from 'rxjs';
import {ObjektSearchService, SearchParameters} from '../../../services/objekt-search.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
    selector: 'object-search',
    templateUrl: './object-search.component.html',
    styleUrls: ['./object-search.component.scss'],
})
export class ObjectSearchComponent {
    public readonly objectSelected = output<any>();
    public readonly useDynamicObjectSource = input.required<boolean>();
    protected readonly objStatusControl = new FormControl<ObjektModels.ObjektStatus[]>([], {nonNullable: true});
    protected readonly projectLeaderControl = new FormControl<ObjektModels.Projektleiter[]>([], {nonNullable: true});
    protected readonly placeControl = new FormControl<ObjektModels.ObjektOrt[]>([], {nonNullable: true});
    protected readonly note4Control = new FormControl<string | undefined>(undefined, {nonNullable: true});
    protected readonly hasSearched: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private readonly objectSearchService = inject(ObjektSearchService);
    private readonly searchInput = viewChild('searchInput', {read: ElementRef<HTMLInputElement>});
    private readonly filterOptions = viewChild('filterOptions', {read: ElementRef<HTMLInputElement>});
    private readonly filterValues = this.objectSearchService.getFilterOptions();
    protected readonly placesFilterOptions = toSignal(this.filterValues.placesFilterOptions);
    protected readonly projectLeaderFilterOptions = toSignal(this.filterValues.projectLeaderFilterOptions);
    protected readonly statusFilterOptions = toSignal(this.filterValues.statusFilterOptions);
    private readonly searchParams = new Subject<SearchParameters>();

    protected readonly searchResults = toSignal(
        this.searchParams.pipe(
            switchMap((params) => (!params ? of([]) : this.objectSearchService.search(params))),
            tap((result) => {
                if (result?.[0]) {
                    this.onObjectSelected(result[0]);
                }
            }),
            tap((res) => {
                this.hasSearched.next(true);
            }),
            catchError((err, caught) =>
                of(err).pipe(
                    tap(() => console.error('Error during object search:', err)),
                    switchMap(() => caught.pipe(startWith([] as ObjectData[])))
                )
            )
        )
    );

    public search(): void {
        const searchString = this.searchInput()!.nativeElement.value.toLowerCase();
        this.searchParams.next({
            searchTerm: searchString,
            note4: this.note4Control.value,
            place: this.placeControl.value,
            projectLeader: this.projectLeaderControl.value,
            objStatus: this.objStatusControl.value,
            useDynamicObjectSource: this.useDynamicObjectSource()
        });
    }

    public onObjectSelected(result: ObjectData): void {
        this.objectSelected.emit(result.objectID);
    }

    public isEnter(ev: KeyboardEvent): void {
        if (ev.key.toLowerCase() == 'enter') {
            this.search();
        }
    }

    public openFilter(): void {
        const classList = this.filterOptions()!.nativeElement.classList;
        if (classList.contains('full')) {
            classList.remove('full');
        } else {
            classList.add('full');
        }
    }
}
